import { createCustomEnum } from "./customEnum";

const ReportFileFormats = createCustomEnum({
	Csv: {
		name: "csv",
		value: 0,
		displayName: "Csv",
	},
	Pdf: {
		name: "pdf",
		value: 1,
		displayName: "Pdf",
	},
	Xls: {
		name: "xls",
		value: 2,
		displayName: "Xls",
	},
});

export default ReportFileFormats;
